import { useLocation, useNavigate } from "react-router-dom";
import { SegmentedTabs } from "./SegmentedTabs";

export type GameKey = "lod" | "roulette" | "kart";

export const GAME_ROUTES: Record<GameKey, string> = {
  lod: "/lod",
  roulette: "/lod/roulette",
  kart: "/lod/kart",
};

/**
 * The switch between the games on the Spil tab. They are separate routes
 * rather than one page with state, so a game can be linked to and so neither
 * has to stay mounted (and rendering) while the other is on screen — which
 * means the pill has no memory of where it was, and the tab that navigated
 * has to say. Same arrangement as the vote/result pair.
 */
export function GameTabs({ active, className = "" }: { active: GameKey; className?: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;

  return (
    <SegmentedTabs
      segments={[
        { key: "lod", label: "COIN" },
        { key: "roulette", label: "RLTT" },
        { key: "kart", label: "KART 🏎️🔥" },
      ]}
      activeKey={active}
      enterFrom={from}
      variant="subtle"
      className={className}
      // Replace, so flipping between the games doesn't pile up steps to
      // back out of on the way to the calendar.
      onSelect={(key) =>
        key !== active &&
        navigate(GAME_ROUTES[key as GameKey], { replace: true, state: { from: active } })
      }
    />
  );
}
